import alt from '../alt';
import leaveAtdAction from '../actions/leaveAtdAction';

class leaveAtdStore {
    constructor() {
        this.bindActions(leaveAtdAction);
        this.processing = false;
        this.summary = [];
        this.isLeaveSuccess = false;
        this.isAtdSuccess = false;
        this.staffId = "";
    }

    onProcessing(data) {
        this.processing = data;
    }
    onStaffId(data) {
        this.staffId = data;
    }
    onIsAtdSuccess(data){
        this.isAtdSuccess = data;
    }
    onSummary(data) {
        this.summary = data;
    }
    onIsLeaveSuccess(data) {
        this.isLeaveSuccess = data;
    }
}

export default alt.createStore(leaveAtdStore, 'leaveAtdStore');


// WEBPACK FOOTER //
// ./app/stores/leaveAtdStore.js